module.exports = __webpack_public_path__ + "media/images/credit_cards/MasterCard-4e2dc73867e71c7e6ed08addfa2d81e9.png";